<template>
  <div class="">
    <!-- :title="route.routeName" -->
    <page-header v-if="route" title="View Route" breadcrumb="Dashboard >> Settings >> Routes >> Route" />

    <div class="custom-card" v-if="route">
      <inter-state-form v-if="isInterstate" :states="states" :route="route" edit />
      <intra-state-form v-if="isIntrastate" :states="states" :route="route" edit />
    </div>

  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

import InterStateForm from '../NewRoute/partials/InterStateForm.vue';
import IntraStateForm from '../NewRoute/partials/IntraStateForm.vue';



export default {
  components: {
    InterStateForm,
    IntraStateForm,
    PageHeader

  },
  data() {
    return {
      routeId: null,
      states: [],
      route: null
      // updatingRoute: false,
    };
  },
  mounted() {
    this.routeId = localStorage.getItem("routeId");
    if (this.routeId) {
      this.getRouteDetails();
    } else {
      this.$router.push({ name: "Route" });
    }
    this.getAllStatesAndCities();
  },
  methods: {
    async getRouteDetails() {
      try {
        let response = await this.$_getSingleRoute(this.routeId);
        console.log(JSON.stringify(response.data.data.shippingService, null, 2));
        this.route = response.data.data.shippingService;
      } catch (error) {
        this.handleError(error);
      }
    },

    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    }
  },
  computed: {
    isInterstate() {
      if (this.route) return this.route.isInterstate;
      else return false;
    },
    isIntrastate() {
      if (this.route) return this.route.isIntrastate;
      else return false;
    },
  },
};
</script>

<style>
</style>
